ScrollHelper = App.load 'core::ScrollHelper'
DeleteDialog = App.loadClass 'core::DeleteDialog'
PlacementStepsKo = App.loadClass 'grower::viewmodels/placement/Steps'

class exports.PlacementHandler extends Handler

    # this keeps the handler from being destroyed while we're at these states
    angular_states: ['grower.placement', 'grower.planting-rx']

    init: ->
        @layoutUrl = 'backend/grower/placement/load-layout'
        @autofocus = false

        msg = App.sidebar.messageWriter()
        msg.message_writer()
        msg.message_writer('info', 'Loading...')

        @loadLayout()


    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            return

        msg = App.sidebar.messageWriter()
        msg.message_writer('success', 'Loaded!')
        msg.message_writer('hide')

        ths = this

        @spps = response.data.spps

        # start new survey
        select = $(@layoutSelector).find('#survey_select')
        $(@layoutSelector).find('#start_survey_button').click =>
            sppID = parseInt select.val()
            @startSurvey sppID

        # unfinished surveys
        ufs = $(@layoutSelector).find('#unfinished_surveys')
        ufsBtn = $(@layoutSelector).find('#finish_survey_button')

        ScrollHelper.make ufs,
            height: 150

        ufs.find('.row-clickable').bind 'click', ->
            ths.selectSurvey $(this), ufsBtn

        ufs.find('.delete-btn').bind 'click', ->
            ths.deleteSurvey $(this)

        ufsBtn.click =>
            @finishSurvey()

        # finished surveys
        fs = $(@layoutSelector).find('#finished_surveys')
        fsBtn = $(@layoutSelector).find('#review_survey_button')

        ScrollHelper.make fs,
            height: 150

        fs.find('.row-clickable').bind 'click', ->
            ths.selectSurvey $(this), fsBtn

        fs.find('.delete-btn').bind 'click', ->
            ths.deleteSurvey $(this)

        fsBtn.click =>
            @reviewSurvey()

        # placement report button
        $(@layoutSelector).find('#placement_report_button').click =>
            $(window).trigger 'spp.placement-report' # MAJOR HAX! TODO: GET RID OF THIS!

        # reset survey button
        $(@layoutSelector).find('#reset_survey_button').click =>
            @resetSurvey()
        .hide()


        # if there is nothing to choose, then auto-start a new spp
        if not ufs.length and not fs.length and not select.is(':visible')
            sppID = parseInt select.val()
            if sppID
                @startSurvey sppID


    afterSurveyLoaded: (spp) ->
        $(@layoutSelector).find('#reset_survey_button').show()

        # Knockout for the sidebar progress stuffs.
        stepList = $(@layoutSelector).find('.spp-step-list')
        @stepListKO = new PlacementStepsKo(spp)
        #ko.cleanNode stepList
        ko.applyBindings(@stepListKO, stepList[0])
        if spp.has_multiple_steps
            stepList.show()


    selectSurvey: (el, btn) ->
        tr = el.closest('tr')
        alreadySelected = tr.hasClass('darken')

        App.sidebar.contentDiv().find('tr').removeClass('darken')
        btn.attr('disabled', 'disabled')

        if not alreadySelected
            tr.addClass('darken')
            btn.removeAttr('disabled')

        @setButtonColor(el)



    deleteSurvey: (el) ->
        # tr = el.closest('tr')

        # postOptions =
        #     result_id: tr.attr('data-id')
        # $.post 'backend/grower/placement/delete-survey', postOptions, (response) ->
        #     if response?.status?.type is 'success'
        #         tr.remove()
        #         setTimeout(() ->
        #             App.current_page.init()
        #         ,1000)
        #     else
        #         # display the error somewhere

        tr = el.closest('tr')
        survey_id = tr.attr('data-id')

        del = @createSubHandler DeleteDialog, "Delete_Dialog_#{survey_id}"
        if del

            #del.layoutUrl = 'backend/grower/machinery/load-layout-delete'
            del.saveUrl             = 'backend/grower/placement/delete-survey'
            del.deleteTitle         = 'Survey'
            del.deleteMessage       = 'this Survey'
            del.deleteItemID        = survey_id
            del.delayAfterSuccess   = true
            del.override_savingText = true
            del.savingText          = 'Deleting...'
            del.savedText           = 'Deleted'
            #del.saveData =
            #    id: survey_id
            del.init()
            del.successAction = () ->
                App.current_page.refresh()


    finishSurvey: () ->
        tr = $(@layoutSelector).find('#unfinished_surveys tr.darken').first()
        if not tr.length then return

        resultID = parseInt tr.attr('data-id')
        sppID = parseInt tr.attr('data-pp-id')

        @startSurvey sppID, resultID


    reviewSurvey: () ->
        tr = $(@layoutSelector).find('#finished_surveys tr.darken').first()
        if not tr.length then return

        resultID = parseInt tr.attr('data-id')
        sppID = parseInt tr.attr('data-pp-id')

        @startSurvey sppID, resultID


    startSurvey: (spp_id, result_id = null) ->
        if not @spps.length
            throw new Error 'No SPPs were loaded'

        spp_name = _.filter(@spps, id: spp_id)[0]?.internal_name
        if not spp_name
            throw new Error 'The selected SPP was not found'
        handler_name = spp_name.replace(/_/g, '') + 'Handler'
        spp = @createSubHandler "grower::handlers/placement/spps/#{handler_name}"

        if spp
            spp.sppID = spp_id
            spp.resultID = result_id ? null
            spp.init()
            $(@layoutSelector).find('#start_survey_area').hide()
        else
            throw new Error("#{spp_name} is not a valid placement program name")


    resetSurvey: () ->
        App.current_page.refresh()


    setButtonColor: (el) ->
        div = el.closest('div#start_survey_area')
        unfinishedTable = div.find('table#unfinished_surveys')
        finishedTable = div.find('table#finished_surveys')
        finishButton = div.find('#finish_survey_button')
        reviewButton = div.find('#review_survey_button')
        startButton = div.find('#start_survey_button')

        if unfinishedTable.find('tr.darken').length
            finishButton.addClass('btn-primary')
            startButton.removeClass('btn-primary')
        else
            finishButton.removeClass('btn-primary')
            if finishedTable.find('tr.darken').length
                startButton.removeClass('btn-primary')
            else
                startButton.addClass('btn-primary')

        if finishedTable.find('tr.darken').length
            reviewButton.addClass('btn-primary')
        else
            reviewButton.removeClass('btn-primary')
